export default {
    "account": {
        "InvoiceDialogue": {
            "title": "Your invoices"
        },
        "bookmark": {
            "list": {
                "actions": "Actions",
                "dt": "date",
                "tags": "Keywords",
                "url": "Web page"
            },
            "menu_name": "my favourites",
            "title": "Rank my favorite sites"
        },
        "entity": {
            "menu_name": "business",
            "title": "My company"
        },
        "form": {
            "avatar": "Avatar",
            "bio": "My story",
            "bio_link": "A URL describing you (must start with https://)",
            "bio_text": "A sentence describing you",
            "birth_date": "Birth Date",
            "email": "e-mail",
            "email_invoice": "Email address for receiving invoices",
            "first_name": "First Name",
            "gender": {
                "label": "Kind",
                "men": "man",
                "non_binary": "Is not pronounced",
                "women": "wife"
            },
            "landline": "Phone",
            "last_name": "Name",
            "mobile_phone": "Mobile phone",
            "second_email": "Second email address",
            "update": "Updated account information.",
            "user_name": "Pseudo"
        },
        "invoices": {
            "menu_name": "Invoices",
            "title": "My bills"
        },
        "logout": "Sign Out",
        "logout_all": "Disconnect all my devices",
        "menu_name": "Disconnect",
        "modify": "Unlock Information",
        "plan": {
            "menu_name": "Subscriptions",
            "title": "My subscriptions"
        },
        "secret": {
            "menu_name": "my secret key",
            "reload": "Generate a new code",
            "subtitle": "It is a key that you can regenerate at any time, you may be asked to validate a sensitive action during your navigation. You should memorize it!",
            "title": "Your secret key"
        },
        "title": "Account info",
        "undo": "Lock information",
        "user": {
            "menu_name": "Identifiers",
            "right": {
                "card": {
                    "moderator": "Moderator"
                },
                "title": "Your business card"
            },
            "title": "Account info"
        }
    },
    "bookmarks": {
        "delete_dialogue": {
            "cancel": "Cancel",
            "ok": "Wipe off",
            "title": "Deleting your favorite"
        },
        "list": {
            "actions": "Actions",
            "delete": "Delete this line",
            "dt": "Add the",
            "edit": "Edit this line",
            "search": "Filtering ",
            "title": "Description",
            "url": "Web page"
        },
        "update_dialogue": {
            "cancel": "To abandon",
            "ok": "Register",
            "title": "Editing your favorite"
        }
    },
    "charts": {
        "statistics": {
            "likes": "Number of likes",
            "names": {
                "progression": "Evolution over three months",
                "raw": "Last daily measurements"
            },
            "prints": "Number of impressions",
            "publications": "Number of posts"
        }
    },
    "common": {
        "accept": "Accept",
        "add": "Add",
        "back": "Previous",
        "cancel": "Cancel",
        "close": "To close",
        "continue": "Carry on",
        "copyClipBoard": "Copy to clipboard",
        "delete": "Remove",
        "form": {
            "avatar": {
                "errors": {
                    "upload": "Unable to update your avatar, please check the format of your file"
                },
                "text": "Change avatar"
            },
            "logo": {
                "errors": {
                    "upload": "Unable to update your logo, please check the format of your file"
                },
                "text": "Change logo"
            },
            "drag_and_drop": {
                "label": "Drop your files here!",
                "size_error": "The file is too large!",
                "type_error": "The supplied file type is incorrect! Allowed files: {type}"
            }
        },
        "locale": "Language",
        "menu": "Menu",
        "months": {
            "april": "April",
            "august": "August",
            "december": "December",
            "february": "February",
            "january": "January",
            "july": "July",
            "june": "June",
            "march": "March",
            "may": "May",
            "november": "November",
            "october": "October",
            "september": "September"
        },
        "more": "Show more...",
        "next": "following",
        "no": "No",
        "no_results": "No items available at the moment",
        "not_required": "Optional",
        "optional": "Optional",
        "preview": "Overview",
        "previous": "Previous",
        "readonly": "unchangeable",
        "save": "Save",
        "skip": "Pass",
        "update": "Update",
        "yes": "Yes"
    },
    "company": {
        "address": {
            "step": "Address"
        },
        "basics": {
            "step": "Recording"
        },
        "confirmation": {
            "step": "CONFIRMATION EMAIL"
        },
        "details": {
            "step": "Details"
        },
        "entity": {
            "menu_name": "My information",
            "title": "Information about my company"
        },
        "form": {
            "category": "Activity area",
            "city": "city",
            "company_name": "Company name",
            "country": "country",
            "department": "Department",
            "email": "e-mail",
            "employees": "number of employees",
            "first_name": "First Name",
            "further_information": "Complement",
            "last_name": "Name",
            "phone": "Phone",
            "siret": "SIRET",
            "street": "Street",
            "zip": "Postal code",
            "headline": "Company's tagline",
            "public_name": "Public name"
        },
        "information": {
            "step": "Information",
            "text": "By following the steps in this form, you will be able to access the moderation of the opinions of your sites."
        },
        "invoices": {
            "actions": "View/Download Invoice",
            "created_at": "Date",
            "menu_name": "My bills",
            "name": "Name",
            "none_selected": "Select an invoice to view it",
            "number": "number",
            "price_gross": "Amount TTC",
            "price_net": "Amount HT",
            "refresh": "Refresh the list of invoices",
            "title": "My bills"
        },
        "plan": {
            "menu_name": "My subscriptions",
            "noSubscription": "You currently don't have any active paid subscriptions.",
            "title": "Manage my subscriptions"
        }
    },
    "dashboard": {
        "account": {
            "menu_tooltip": "Account\n- Identifiers\n- Business\n- Subscriptions\n- Invoices",
            "title": "My\nAccount"
        },
        "company": {
            "address": "Address",
            "identification": "Company identification",
            "manager": "Contact person (for billing)",
            "plan": {
                "amount": "Amount",
                "available": "Subscriptions available",
                "available_tokens": "No site attached on {amount} | {used} site attached on {amount} | {used} sites attached on {amount}",
                "billingLabel_0": "Monthly",
                "billingLabel_1": "Annual",
                "billingTranslation": "Renewal {billing}",
                "counter": "Credits available:",
                "created_at": "Transaction date and time",
                "discountTranslation": ", with a reduction of <strong>{discount}</strong>.",
                "from": "Subscriber since",
                "list": {
                    "title": "My subscriptions"
                },
                "modal": {
                    "create": {
                        "isFree": "FREE subscription is always included",
                        "pay": "Pay my subscription",
                        "title": "New Subscription"
                    },
                    "ordered": {
                        "cancel": "To close",
                        "status": {
                            "0": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Thank you for placing your order.<br><br>For the moment we have not received confirmation of receipt of your payment.<br><br>You will be notified by email upon receipt.",
                            "1": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Thank you for placing your order.<br><br>Your payment has not reached us yet.<br><br>You will be immediately informed by email upon receipt.",
                            "2": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Thank you for placing your order.<br>Unfortunately the settlement failed.<br><br>We invite you to renew your payment.",
                            "3": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Unfortunately this subscription has been cancelled.<br><br>We invite you to simply renew your subscription.",
                            "4": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>The payment corresponding to your order could not be taken into account.<br>You can just try again.",
                            "5": "<i class='fas fa-check succes--text font-weight-bold'></i> Your request has been taken into account<br><br>The payment corresponding to your order has been refunded.<br><br>Thank you again for your trust.",
                            "6": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Warning<br><br>Payment for your order has not yet been received.<br><br>You will be immediately informed by email upon receipt.",
                            "7": "<i class='fas fa-check succes--text font-weight-bold'></i> Your request has been taken into account<br><br>Thank you for placing your order.<br>You can now assign this subscription to your sites.<br><br>To do this, go to the <strong>Sites</strong>tab.",
                            "unknown": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Warning<br><br>Your order could not be finalized,<br><br>our sales department has been informed and will get back to you as soon as possible.<br><br>You can also just try again."
                        },
                        "title": "Confirmation of your order"
                    },
                    "update": {
                        "cancel": "Cancel automatic renewal",
                        "nothing": "No action possible on this subscription for the moment.",
                        "title": "Changing the subscription"
                    }
                },
                "next": "Next Due Date",
                "noDiscountTranslation": ". With the annual renewal, take advantage of an immediate reduction.",
                "order": "Add a subscription",
                "planColor_0": "GRAY",
                "planColor_1": "Orange",
                "planColor_2": "GREEN",
                "planColor_3": "BLUE",
                "planColor_4": "Yellow",
                "planIcon_0": "fa-child",
                "planIcon_1": "fa-male",
                "planIcon_2": "fa-walking",
                "planIcon_3": "fa-running",
                "planIcon_4": "fa biking",
                "planLabel_0": "Free",
                "planLabel_100": "Discover",
                "planLabel_1": "Start",
                "planLabel_2": "Smart",
                "planLabel_3": "Max",
                "planLabel_4": "No limit",
                "planStatus_0": "Subscription to pay",
                "planStatus_1": "waiting for payment",
                "planStatus_2": "Settlement Failed",
                "planStatus_3": "Settlement expired",
                "planStatus_4": "Payment abandoned",
                "planStatus_5": "Subscription refunded",
                "planStatus_6": "Subscription pending payment",
                "planStatus_7": "Subscription in progress",
                "planTranslation": "Subscription <strong>{plan}</strong>",
                "preview": {
                    "qte": "Qty",
                    "ref": "Ref",
                    "total_vat_excluded": "Total HT",
                    "total_vat_included": "Total price",
                    "vat_amount": "VAT Amount",
                    "vat_excluded": "PU HT",
                    "vat_rate": "VAT"
                },
                "refresh": "Refresh the list of subscriptions",
                "secure_by_mollie": "Secure payment made by",
                "selected": "Chosen subscription offer",
                "total": "Billing overview",
                "until": "subscription active until the date of",
                "viewAllSubsciption": {
                    "setToFalse": "See only current subscriptions",
                    "setToTrue": "See all subscriptions"
                },
                "woTva": "HT"
            },
            "title": "business"
        },
        "documentation": {
            "title": "Documentation"
        },
        "extension": {
            "title": "Download extension"
        },
        "feed": {
            "title": "News"
        },
        "formsInputErrors": "Please correct the following errors",
        "groups": {
            "title": "Groups"
        },
        "help": {
            "hide": "Hide help",
            "hide_menu_name": "Hide help",
            "show": "Show help",
            "show_menu_name": "Show help",
            "title": "Help"
        },
        "invitation": {
            "menu_tooltip": "invitations\n- Invitation follow-up\n- Creation of an invitation\n- Identify my customers",
            "title": "Invitations",
            "tracking": {
                "menu_name": "Invitation Tracking",
                "metas": "Associated meta-information",
                "title": "Invitation Tracking"
            }
        },
        "navigation": {
            "close": "Close tab",
            "maximize": "Expand menu",
            "minimize": "Collapse Menu"
        },
        "notifications": {
            "title": "Notifications"
        },
        "parameters": {
            "menu_tooltip": "Configuration\n- List of profiles\n- Review behavior",
            "title": "My\nSettings"
        },
        "products": {
            "menu_tooltip": "Products\n- My products\n- Add a product\n- Import my products\n- My Marks",
            "title": "My\nProducts"
        },
        "qualify": {
            "title": "Qualification"
        },
        "ranking": {
            "created": "Member since",
            "publications": "Publications",
            "title": "ranking"
        },
        "refresh": "Reload List",
        "reviews": {
            "generation": {
                "form": {
                    "all": "View all reviews.",
                    "submit": "Generate List"
                },
                "infos": "Information",
                "list": "See the list",
                "menu-title": "Generation",
                "title": "My review list"
            },
            "menu_tooltip": "Opinion\n- Site reviews\n- Product reviews",
            "title": "My reviews"
        },
        "reviewsModeration": {
            "deadlock": "The post is locked by another user ({date}).\n<br> Please try again in a few moments.",
            "dialogs": {
                "cancel": {
                    "text": "Do you confirm the cancellation of the modifications in progress?",
                    "title": "cancellation"
                },
                "publish": {
                    "success": "The review has been published",
                    "text": "Do you confirm the passage of this notice in public?",
                    "title": "Moderation Status"
                },
                "remove": {
                    "text": "Do you confirm the deletion of the review? You cannot go back.",
                    "title": "Confirmation"
                },
                "report": {
                    "success": "The review has been rejected",
                    "text": "Would you like to report this review?\n The confidence level of the review will drop drastically and will not be displayed. <br>Warning ! Reporting a review for the wrong reasons may be subject to penalties.\n",
                    "title": "Report a review"
                }
            },
            "filters": {
                "confidence": "Review confidence level",
                "created_at": "Publication date",
                "order": {
                    "asc": "Descending",
                    "desc": "increasing"
                },
                "rating": "User Rating",
                "title": "Organize the list of reviews",
                "title_order": "List ranking",
                "title_sort": "sort by"
            },
            "generation": {
                "at": "at",
                "documentation": "Documentation of the moderation module",
                "form": {
                    "from": "Notice from",
                    "group": "Group of moderators",
                    "moderate": "Include already moderated reviews",
                    "submit": "Create List"
                },
                "generate_menu_name": "Create list of reviews",
                "generated": "Creation in progress",
                "infos": "Information",
                "last_generate": "Latest creation",
                "last_refresh": "last upload",
                "list": "See the list",
                "menu-title": "Generation",
                "processing": "Your request has been taken into account, it may take a few seconds to process. Use the <b>'REFRESH LIST' button</b> to load your publication list.",
                "refresh_menu_name": "Refresh the list of reviews",
                "title": "Create list of reviews"
            },
            "list": {
                "confidence": "Review confidence level",
                "created_at": "Date of writing",
                "empty": {
                    "criteres": "Your criteria:",
                    "fromDate": "Publication created after the date of:",
                    "messageEmptyResult": "Unfortunately, no publication corresponds to your request!",
                    "moderated_no": "Unmoderated publication",
                    "moderated_yes": "Post already moderated",
                    "refreshAllReadyNotDone": "No information is available at the moment.",
                    "requestDateTime": "Date and time of request"
                },
                "like_counter": "{n} like | {n} like",
                "moderate": "Moderation Status",
                "moderated": "moderate",
                "not-moderated": "Not moderated",
                "private": "Personal note",
                "rating": "Review rating",
                "rejected": "Rejected",
                "title": "List of notices",
                "updated_at": "Date of last update"
            },
            "refresh": {
                "reload": "Load list",
                "title": "Load from list"
            },
            "response": {
                "buttons": {
                    "back": "Previous",
                    "cancel": "discard changes",
                    "delete": "Delete answer",
                    "edit": "Edit answer",
                    "publish": "Publish review",
                    "reply": "REPLY",
                    "report": "Dismiss Review",
                    "update": "following"
                },
                "context": {
                    "from_order": "Opinion of an Influencer or a Customer?",
                    "from_order_false": "Influencer.",
                    "from_order_true": "Customer",
                    "gift_description": "Description of counterparty",
                    "hashtag": "Associate a Hashtag",
                    "hashtag_help": "A single capitalized word that allows your reviews to be grouped.",
                    "order_date": "Date of the order",
                    "order_info_type_service": "Service Information",
                    "order_item_code": "Reference ordered",
                    "order_item_desc": "Product/service name",
                    "order_item_type": "'The order concerns",
                    "order_item_type_product": "A product",
                    "order_item_type_service": "a service",
                    "order_mandatory_info": "Required information",
                    "order_number": "order number",
                    "order_optional_info": "Additional order information",
                    "order_service_begin": "Start date",
                    "order_service_end": "End date",
                    "with_gift": "Opinion with a counterparty?",
                    "with_gift_false": "No",
                    "with_gift_true": "Yes"
                },
                "message": "Give an answer (optional)",
                "message_help": "Such as thanks, additional explanations, etc.",
                "pertinence": "Relevance of review",
                "publish": "Rate the relevance of the review",
                "report": {
                    "1": "rude or vulgar",
                    "2": "Discrimination, incitement to hatred",
                    "3": "Public humiliation",
                    "4": "Spam",
                    "5": "Commercial content or self-promotion",
                    "6": "Private communication message",
                    "7": "Security, fraud or legal issue",
                    "8": "Threatens the physical integrity of a person",
                    "9": "Violation of a person's privacy",
                    "label": "Reason for rejection",
                    "title": "Report review"
                },
                "title": "Validate the review",
                "update_date": "{date}",
                "locale": "Original Language of Review"
            },
            "response_done": {
                "buttons": {
                    "change": "Re-validate this review"
                },
                "message": "Answer currently visible",
                "moderation_done": "Your customer's review has been processed",
                "no_message": "You didn't give an answer",
                "pertinence": "Relevance of review",
                "publish": "Publish the review to make it visible",
                "report": {
                    "1": "rude or vulgar",
                    "2": "Discrimination, incitement to hatred",
                    "3": "Public humiliation",
                    "4": "Spam",
                    "5": "Commercial content or self-promotion",
                    "6": "Private communication message",
                    "7": "Security, fraud or legal issue",
                    "8": "Threatens the physical integrity of a person",
                    "9": "Violation of a person's privacy",
                    "label": "Reason for rejection",
                    "title": "Report review"
                },
                "title": "Update to this notice",
                "update_date": "{date}"
            },
            "review": {
                "body": "Moderation link -> {url}",
                "buttons": {
                    "cancel": "discard changes",
                    "delete": "Delete Review",
                    "edit": "Edit review",
                    "update": "Edit review"
                },
                "card_title": "Notice Details",
                "copied": "The moderation link has been copied to your clipboard!",
                "edit": "Edit review",
                "external": "See the opinion on the site",
                "link": "Copy a moderation link",
                "mailto": "Email this link",
                "message": "Message",
                "response": "REPLY",
                "review": "View",
                "review_link": "View the review on the site",
                "solicitation": "Collected using an invite",
                "not_solicitation": "Free opinion",
                "customer_without_solicitation": "Customer free opinion",
                "subject": "Here is a link to moderate a review.",
                "title": "title",
                "update_date": "Review edited by user on {date}",
                "viewSolicitation": "View the invite"
            },
            "tabs": {
                "author": "Author",
                "gift": "Counterparty",
                "hashtag": "Hashtag",
                "order": "Order",
                "response": "REPLY"
            },
            "title": "View"
        },
        "social": {
            "title": "Invitations"
        },
        "statistics": {
            "menu_tooltip": "Statistics\n- Invitation follow-up"
        },
        "stories": {
            "menu_tooltip": "Stories\n- Stories",
            "title": "Stories"
        },
        "suggestions": {
            "menu_tooltip": "Hints\n- Your pages\n- Settings",
            "title": "Suggestions"
        },
        "urls": {
            "title": "Pages"
        },
        "userGroups": {
            "title": "Groups"
        },
        "wall": {
            "title": "Personal page"
        },
        "websites": {
            "menu_tooltip": "Websites\n- My websites\n- Personal page",
            "title": "My\nWebsites"
        }
    },
    "documentation": {
        "editor": {
            "dialog": {
                "title": "Documentation overview"
            },
            "form": {
                "path": "Path to documentation (unique)"
            },
            "path": "Unique Identifier",
            "remove": "Remove",
            "reset": "New",
            "save": {
                "error": "Unable to save",
                "success": "safeguard"
            },
            "title": "Identification of documentation",
            "toolbar": {
                "bold": "Fat",
                "clear": "Delete Content",
                "code": "Code",
                "comment": "Comments",
                "fullscreen": "Full screen mode",
                "heading": "title",
                "help": "Understanding markdown",
                "image": "Picture",
                "italic": "Italics",
                "link": "Link",
                "ol": "Ordered list",
                "preview": "Overview",
                "quote": "Quote",
                "strikethrough": "Rod",
                "table": "Board",
                "ul": "Bulleted List",
                "youtube": "Youtube"
            }
        },
        "empty": "<b>Documentation: </b><b class='red--text'>{path}</b><br><br> This documentation is not written at the moment.",
        "menu_name": "Help with use",
        "preview": {
            "title": "Help and Documentation"
        },
        "title": "Documentation and help for use"
    },
    "feed": {
        "product": {
            "intro": {
                "manager": "Product Notice",
                "me": "The review concerns the product"
            }
        },
        "thematic": {
            "intro": {
                "manager": "Notice regarding",
                "me": "The notice concerns"
            }
        },
        "top": {
            "menu_name": "Ranking of contributors",
            "title": "Rankings of the best contributors"
        },
        "user": {
            "menu_name": "User posts"
        },
        "wall": {
            "menu_name": "My News Feed",
            "title": "Your News Feed"
        }
    },
    "form": {
        "errors": {
            "62ab17c4-407a-11eb-8a64-9ff6b4495c19": "This nickname is already used.",
            "7cd5874c-407a-11eb-8647-3730f1b86ed8": "An error occurred while creating your account, please try again later.",
            "7eab69d0-4078-11eb-9248-4328374c61e3": "The email address is already used.",
            "E000000": "Unknown error",
            "E100000": "Manager error",
            "E110000": "Mistake of the pro manager",
            "E111000": "Manager pro error / Registration",
            "E111001": "Creation is impossible because an account already exists with this email",
            "E111002": "The creation of your account is impossible because your nickname has already been reserved by another user",
            "E120000": "Personal manager error",
            "E200000": "API error",
            "E210000": "Publish micro service error",
            "E220000": "Suggestion micro service error",
            "E230000": "Robot micro service error",
            "label": "FAULT"
        },
        "fields": {
            "birth_date": "Birth Date",
            "company_name": "Company name",
            "email": "e-mail",
            "first_name": "First Name",
            "landline": "numeric|nullable|max:15",
            "last_name": "Name",
            "mobile_phone": "numeric|nullable|max:15",
            "phone": "Phone",
            "vat_number": "Intracommunity VAT number"
        },
        "key": "Key",
        "keys": "Keys",
        "validation": {
            "alpha": "Only expected letters",
            "before": "The date seems wrong",
            "numeric": "Only expected numbers"
        },
        "value": "Value",
        "values": "Values"
    },
    "groups": {
        "form": {
            "add": "Add",
            "title": "Start a new group"
        }
    },
    "invitation": {
        "csv": {
            "convert": "Send your file",
            "copied": "The contents of the CSV file have been copied!",
            "dialog": {
                "copy": "To copy",
                "download": "Download",
                "title": "Your enriched CSV files"
            },
            "drag_and_drop": "Your CSV files",
            "filters": {
                "include_securating_accounts": "Exclude active Securating accounts",
                "title": "Filtering "
            },
            "menu_name": "Create multiple invites",
            "options": {
                "send_file": "Download only your enriched file",
                "send_mail": "Automatically send an email to each contact in your file",
                "title": "Options"
            },
            "title": "Transfer of your emailing file for the collection of your opinions",
            "upload_error": "An error occurred while sending the files. Please try again."
        },
        "dialogs": {
            "url": {
                "title": "Your invite link"
            }
        },
        "emailing": {
            "bt": {
                "clear": "Clear form",
                "send": "Create an invite"
            },
            "form": {
                "company_name": "Company name to display",
                "customer_avatar": "URL of your client's logo",
                "customer_bio": "Position held",
                "customer_gender": "Civility",
                "customer_link": "Your client's website",
                "email": "E-mail adress",
                "first_name": "First Name",
                "last_name": "Last Name",
                "path": "Collection page web address (must start with a '/')",
                "product": "Product code (25:0001)",
                "template_mail": "Email template",
                "thematics": "Survey topic codes (100100,100200)",
                "url": "https://your-site.com/your-page"
            },
            "gift_description": "Description of counterparty",
            "hashtag": "Hashtag",
            "locale": "Invitation email language",
            "mail": {
                "nok": "An error has occurred! Your invitation could not be sent",
                "ok": "Your invitation has been sent to"
            },
            "mail_delay": "Delay before sending the first email",
            "mail_delay_input": "Time in days",
            "menu_name": "Create an invite",
            "options": {
                "send_mail": "Send the invitation to your contact by email",
                "send_url": "Download invitation url",
                "title": "Options"
            },
            "title_about": "Data to be collected",
            "title_about_choice" : "Review site / Product / Survey ",
            "options_type": {
                "pro": "Product Review",
                "pro_son": "Product review with survey",
                "ser": "Site reviews",
                "ser_son": "Site review with survey",
                "son": "Survey only"
            },
            "title_external": "Urls to include",
            "title_external_choice": "Securating / External link / All",
            "options_external_link": {
                "no" : "Only Securating's link",
                "only" : "Only external link",
                "both" : "Include all links"
            },
            "order_date": "Date of the order",
            "order_item_code": "Reference",
            "order_item_desc": "Commercial description",
            "order_item_type": "Object of the order",
            "order_item_type_product": "Ordering products",
            "order_item_type_service": "Service Order",
            "order_number": "order number",
            "order_service_begin": "Service Start Date",
            "order_service_end": "End date",
            "profile": "Moderator",
            "profiles": "Moderator",
            "recall_count": "Resend invitation email",
            "recall_count_input": "Number of raises",
            "recall_delay": "Delay between two raises",
            "recall_delay_input": "Time in days",
            "step_modele": "Email template",
            "step_moderator": "Moderator",
            "step_names": "Customer",
            "step_order": "Order",
            "step_periode": "Reminders and deadlines",
            "step_type": "Invitation parameters",
            "step_url": "collection url",
            "title": "Creation of an invitation: (Customer review, Product review, Survey)",

            "title_customer": "Person invited to give their opinion",
            "title_customer_pro": "Professional information?",
            "title_from": "Opinion collection URL",
            "title_locale": "Email language and model",
            "title_order": "Order Information",
            "title_profile": "Profile of the moderator making the request",
            "title_who": "Name of the company for which the review is collected",
            "url": {
                "nok": "An error has occurred! Your invite link could not be built",
                "ok": "Your invitation link has been built successfully"
            },
            "website": "collection site",
            "website_not_selected": "Select a site to continue",
            "with_gift": "Notice was in exchange for consideration"
        },
        "manual": {
            "menu_name": "Identify my customers",
            "title": "Research and identification of your customers among Securating users"
        },
        "title": "Invitations",
        "tracking": {
            "cancel": "Cancel the request",
            "canceled_at": "Cancellation Date",
            "close": "To close",
            "created_at": "invitation date",
            "delete": "Delete Request",
            "confirm_domain": "Confirm site review",
            "confirm_product": "Confirm product review",
            "confirm_thematic": "Confirm thematic review",
            "email": "Customer Email",
            "link": "Link to invite",
            "list": {
                "created_at": "Invitation generation date",
                "infos": {
                    "1": "January",
                    "2": "February",
                    "3": "March",
                    "4": "April",
                    "5": "May",
                    "6": "June",
                    "7": "July",
                    "8": "August",
                    "9": "September",
                    "10": "October",
                    "11": "November",
                    "12": "December",
                    "not_pending": "Opinions filed",
                    "pending": "unanswered invitations",
                    "percentage": "Response rate",
                    "title": "Statistics for the last three months",
                    "total": "Number of invitations"
                },
                "moderated": "Operation finished",
                "not_moderated": "In progress",
                "title": "List of your latest invitations",
                "keywords": "Search with few keywords",
                "websites": "Choose a location"
            },
            "mail_1_resend_at": "First raise",
            "mail_2_resend_at": "Second raise",
            "mail_3_resend_at": "Last relaunch",
            "mail_delay": "Initial delay before sending the first email",
            "mail_delay_format": "",
            "mail_next_resend_at": "Next Relaunch",
            "mail_resent_nb": "Number of raises remaining",
            "menu_name": "Invitation Tracking",
            "meta_data": "Associated metadata",
            "meta_data_custom": "Other",
            "meta_data_customer": "To your customer",
            "meta_data_gift": "At the counterpart",
            "meta_data_metas": "To your wishes",
            "meta_data_order": "On Order",
            "name": "Client name",
            "no_more_resend": "Any",
            "order": "Order reference",
            "ordered_at": "Order date",
            "product": "product concerned",
            "profile": "Moderator",
            "row": "Click to see the details of the invitation",
            "table": {
                "client": "Customer",
                "created_at": "invitation date",
                "mail_account": "Verification email sent",
                "mail_account_verified": "Publication verified by the client",
                "mail_clicked": "Open invite link",
                "mail_send": "First email sent",
                "profile": "Moderator profile",
                "publication_moderated": "Moderated publication",
                "token_used": "Deposited publication",
                "need_revalidate": "Publication to confirm",
                "is_revalidated": "Publication confirmed"
            },
            "thematics": "Subjects concerned",
            "title": "Invitations Tracking",
            "revalidate" : {
                "title" : "Re-confirmation de l'avis",
                "revalidate_type" : "Type d'avis à reconfirmer",
                "revalidate_type_D" : "Avis site",
                "revalidate_type_P" : "Avis produit",
                "revalidate_type_T" : "Avis thématique",
                "revalidate_type_A" : "Tous les type d'avis",
                "need_revalidate_true" : "Vous avez demandé une re-confirmation de l'avis",
                "need_revalidate_false" : "Aucune demande de re-confirmation n'a été demandée",
                "is_revalidated_true" : "Le contenu de l''avis a bien été re-confirmé par son auteur",
                "is_revalidated_false" : "Le contenu de l'avis n'a pas encore été re-confirmé par son auteur",
                "revalidated_at" : "Date de confirmation ",
            }
        }
    },
    "locales": {
        "fr": "French",
        "en": "English",
        "es": "Spanish",
        "it": "Italian",
        "de": "German",
        "xx": "Others",
    },
    "login": {
        "error": "Error during connection, incorrect email address or password!",
        "form": {
            "email": {
                "label": "Email address or Nickname"
            },
            "password": {
                "label": "Password"
            },
            "recover": "Forgot your password ?",
            "registration": "create my account",
            "registration_pro": "create my account"
        },
        "go": {
            "access": "Access",
            "access_title": "Go to the portal",
            "manager": "business",
            "me": "Internet user"
        },
        "return": "I already have an account",
        "submit": "Log In",
        "title": "Log In"
    },
    "manager": {
        "moderation": {
            "errors": {
                "token_expiration": {
                    "link": "Return to my space",
                    "message": "The moderation link has expired, links expire automatically after 4 days. You can return to your space to generate a new one at any time.",
                    "title": "Oops, an error has occurred!"
                }
            },
            "reviews": {
                "filter_both": "It does not matter",
                "filter_no": "No",
                "filter_marked": "Identified",
                "filter_undefined": "Without information",
                "filter_yes": "Yes",
                "from_order": "With command:",
                "generate_list": "research",
                "moderated": "Show reviews:",
                "moderated_published": "Published",
                "moderated_rejected": "Rejected",
                "not_moderated": "Not moderated",
                "search": "Search by keywords",
                "search_hashtag": "Search in #Hashtags",
                "search_keywords": "Enter your search here",
                "search_no": "No research",
                "search_products": "Search in products",
                "search_publications": "Search reviews",
                "search_users": "Search by user",
                "title": "Search by keywords",
                "title_filter_data": "Filtering by context",
                "title_filter_state": "Search By State",
                "websites": "Choose a site to moderate",
                "with_gift": "With consideration:",
                "locale": "With language: ",
                "with_solicitation": "With invitation: ",
                "order_date" : "Order date",
                "order_number" : "Order number",
            }
        },
        "websites": {
            "list": "Choose a location",
            "selected": "Site selected",
            "title": "Site selection"
        }
    },
    "me": {
        "pages": {
            "validation_token": {
                "collect_publication": "Your post has been taken into account.",
                "invalid_token": "Action impossible, please check your link, it seems incorrect.",
                "title": "Confirmation of your publication"
            }
        }
    },
    "menu": {
        "bookmark": {
            "list": {
                "actions": "Actions",
                "dt": "date",
                "tags": "Keywords",
                "url": "Web page"
            },
            "menu_name": "my favourites",
            "title": "Rank my favorite sites"
        },
        "company": {
            "menu_name": "MAIN MENU",
            "right": {
                "title": "Statistics"
            },
            "title": "MAIN MENU"
        },
        "documentation": {
            "menu_name": "Documentation",
            "title": "Documentation"
        },
        "groups": {
            "add": "Add to group",
            "admin": "Administrator",
            "edit": "Click on a group to edit it or add people to the group",
            "editing": {
                "avatar": "Avatar (url)",
                "description": "Description",
                "members": "Find members to add",
                "title": "Name"
            },
            "isAdmin": "Currently administrator",
            "leave": "Leave the group",
            "members": "Group Members",
            "menu_name": "My Groups",
            "promote": "Promote to Admin",
            "remove": "Exit group member",
            "right": {
                "title": "Group information"
            },
            "title": "Manage my groups",
            "updated": "💾 &nbsp; Group information has been successfully updated"
        },
        "logoutDialogue": {
            "text": "Do you really want to disconnect?",
            "title": "Confirmation?"
        },
        "noPermission": "You do not have access to this feature.",
        "organized": {
            "grid": "Grid View",
            "row": "line display"
        },
        "qualify": {
            "title": "Qualification"
        },
        "suggest": {
            "menu_name": "My Sites",
            "title": "Suggest a site"
        },
        "suggestDialogue": {
            "host": "name of the site",
            "text": "Indicate the name of the site that you would like to see added to our suggestions",
            "title": "Site proposal"
        },
        "user": {
            "menu_name": "Dashboard",
            "title": "My Dashboard"
        },
        "validate": {
            "list": {
                "action": "stock",
                "date": "Date",
                "empty": "Nothing to validate for the moment.",
                "reject": "To reject",
                "title": "title",
                "type": "Type",
                "url": "Site",
                "validate": "Validate"
            },
            "menu_name": "Validation of publications",
            "title": "Validate my posts",
            "type": {
                "1": "View",
                "2": "Media",
                "3": "Question",
                "4": "REPLY"
            }
        }
    },
    "messages": {
        "account": {
            "activation_allready": "Please note that your account has already been activated.",
            "activation_error": "Please note that your account cannot be found.",
            "activation_ok": "Your account has been successfully activated."
        },
        "buttonGoBackOffice": "Go to your personal space.",
        "defaultMessage": "The whole team thanks you for using our services.",
        "loadingDefault": "Loading your information"
    },
    "moderation": {
        "products": {
            "menu_name": "Product reviews"
        },
        "reviews": {
            "menu_name": "Site reviews"
        }
    },
    "notifications": {
        "list": {
            "menu_name": "My notifications",
            "title": "Notifications"
        }
    },
    "origin": {
        "av": "Verified reviews",
        "se": "Securing",
        "source": "Review Source"
    },
    "parameters": {
        "profiles": {
            "cancel": "Cancel",
            "create": "Create Profile",
            "created_at": "Creation date",
            "delete": "Delete profile",
            "error": {
                "create_profile": "Error creating profile",
                "delete_profile": "Error deleting profile",
                "fetch_counters": "Error loading profile statistics",
                "fetch_profiles": "Error loading profile list",
                "update_profile": "Error updating profile"
            },
            "menu_name": "List of Profiles",
            "name": "Moderator name or nickname",
            "new": "New profile",
            "nothing": "No profile yet",
            "public_id": "Moderator's public ID (not editable)",
            "refresh": "Refresh the list of moderators",
            "selected": "Moderator profile",
            "title": "List of moderator profiles",
            "update": "Update profile",
            "updated_at": "Last Update"
        },
        "reviews_params": {
            "menu_name": "Review behavior",
            "title": "Setting up the list of reviews on your site"
        },
        "thematics_params": {
            "menu_name": "Survey topics"
        },
        "title": "Configuration"
    },
    "pass": {
        "form": {
            "password": "Password"
        },
        "submit": "Change my password",
        "title": "reset your password"
    },
    "products": {
        "brand": {
            "accept_legals": "of confirmation",
            "add": "Add a brand",
            "bsin": "Standard Brand Identification Number (BSIN)",
            "cancel": "Return",
            "description": "Description",
            "help": "If your brand is not listed, please add it before entering your products.",
            "i_accept_legals": "I certify that this mark belongs to me",
            "label": "Brands",
            "menu_name": "My brands",
            "name": "Brand name",
            "owner": "*You cannot edit this brand as it is not linked to your account.",
            "save": "Save",
            "title": "Information about my brands",
            "website": "website"
        },
        "product": {
            "add": "Add a Product",
            "brand": "Product Brand",
            "by_csv": "Via a CSV file",
            "by_form": "Via a simple form",
            "cancel": "back",
            "commercial_description": "Business description",
            "commercial_name": "Trade name",
            "create": "Create my product",
            "drag_and_drop": "Your CSV file",
            "ean": "Public code of your product (EAN, etc)",
            "exclude_free": "Hide unsolicited reviews",
            "get_error": "Unable to load this product listing.",
            "help": "You can create, update your products from a CSV file.",
            "help_bis": "Before creating products, think about referencing your brand.",
            "image_url": "Url of the thumbnail image of this product",
            "internal_code": "Internal reference code",
            "invitation_url": "Url to use for invitations",
            "is_sharable": "Reviews of this product are only displayed on your sites",
            "is_visible": "Reviews of this product are not published.",
            "list": "Your products",
            "product_familly": "Other products codes associated",
            "rate": "Calculate my product rating",
            "review_description": "Help text for collecting a review",
            "send": "Send file(s)",
            "title": "Add my products",
            "update": "Save and back",
            "upload_error": "Unable to process your files, please check their structure (See documentation)."
        },
        "product_add": {
            "menu_name": "Add a Product",
            "title": "Add a Product"
        },
        "product_import": {
            "menu_name": "Import my products",
            "title": "Import my products"
        },
        "product_list": {
            "actions": {
                "delete": "Delete this product",
                "edit": "Edit this product",
                "view": "Load Statistics"
            },
            "list": "Index of your products",
            "list_info": "<select><option>My Product-A</option><option>My Product-B</option></select>",
            "menu_name": "My products",
            "title": "Information about your products"
        },
        "product_statistics": {
            "details": "Breakdown of customer reviews by Ratings",
            "no_data": "No information available at the moment.",
            "note_1": "customer reviews have received a rating of 1/5",
            "note_2": "customer reviews received a rating of 2/5",
            "note_3": "customer reviews received a rating of 3/5",
            "note_4": "customer reviews received a rating of 4/5",
            "note_5": "customer reviews received a rating of 5/5",
            "product": "Product",
            "publicationsCount": "Number of customer reviews",
            "rating": "Average grade",
            "selection_needed": "Select a product to view its statistics",
            "title": "Statistics"
        },
        "product_update": {
            "menu_name": "Edit a product",
            "title": "Edit a product"
        }
    },
    "qualify": {
        "manual": {
            "bt": {
                "clear": "Clear this list",
                "crypt": "Encrypt my email list",
                "send": "Identify this list"
            },
            "form": {
                "mails": "List of emails of the accounts you want to identify (one email per line)",
                "title_website": "Site for which you want to qualify the authors of publications"
            },
            "messages": {
                "cryptDone": "Your emails have been encrypted, you can now request their identification.",
                "cryptNotDone": "Some emails do not seem valid, please correct them.",
                "sendDoneError": "An error has occurred, please rephrase your request.",
                "sendDoneMore": "%d new identifiers have been added.",
                "sendDoneNone": "No new identifier has been added.",
                "sendDoneOne": "A new identifier has been added.",
                "sendDoneMorePublication": "%d new reviews has been marked.",
                "sendDoneNonePublication": "No new review has been marked.",
                "sendDoneOnePublication": "A new review has been marked."
            },
            "title": "Research and identification of your customers among Securating users"
        }
    },
    "ranking": {
        "messages": {
            "loading": "Search for the latest publications of"
        }
    },
    "recover": {
        "emailing": "We have <strong>sent you</strong> an email to reset your password, please <strong>follow the</strong> link in the body of the email.",
        "form": {
            "email": "E-mail adress",
            "password": "Password"
        },
        "submit": "Receive an email",
        "title": "Forgot your password ?"
    },
    "registration": {
        "contact": "Your business contact information",
        "end": "Registration completed",
        "end_text": "Your registration is complete <b></b>.\n Please activate your account via the <b>link</b> that we sent to you <b>by email</b>. <br><br> You can then log in to your account by accessing the login form by clicking on the &laquo; <b>LOGIN</b> &raquo; button below.",
        "form": {
            "company": {
                "address": {
                    "city": "city",
                    "country": "country",
                    "further_information": "Address supplement",
                    "street": "Address",
                    "zip": "Postal code"
                },
                "category": "sectors",
                "company_name": "Name of your company",
                "department": "Service",
                "email": "Your company email address",
                "employees": "Effective",
                "first_name": "First Name",
                "host": "Domain name or website",
                "id": "Securing account number",
                "last_name": "Name",
                "password": "Password",
                "phone": "Phone",
                "siret": "Registration number (Siret, etc.)",
                "vat_number": "Intra-community VAT number (European company)"
            },
            "legal": {
                "manager": {
                    "accept_legals": "Terms of Sales",
                    "i_accept_legals": "By clicking Register, you agree to our ",
                    "i_accept_newsletter": "You may receive email notifications from us and you can unsubscribe at any time.",
                    "i_accept_privacy": "and our ",
                    "link_accept_legals": " Terms of Sales",
                    "link_accept_privacy": " Data Use Policy."
                },
                "me": {
                    "accept_legals": "Terms of Service",
                    "i_accept_legals": "By clicking Register, you agree to our ",
                    "i_accept_newsletter": "You may receive email notifications from us and you can unsubscribe at any time.",
                    "i_accept_privacy": "and our ",
                    "link_accept_legals": " terms and conditions",
                    "link_accept_privacy": " Data Use Policy."
                }
            },
            "success": "Please check your email and click on the link to activate your account.",
            "user": {
                "email": "E-mail adress",
                "password": "Password",
                "user_name": "Pseudo"
            }
        },
        "help": {
            "company": {
                "category": "On the first click, select your sector of activity. <br> On the second click, the precision. <br> To correct your entry, click your selection again.",
                "email": "You can choose to use a different email for your entity and your management account. <br> We will use this address to send you notifications related to your entity.",
                "host": "If you have several sites, note here the domain name you want. <br> Once your account has been created, go to \"menu\" then \"site\" and complete the names of the remaining domains.",
                "siret": "By choosing to enter your Siret number as your identifier, <br> the following fields are filled in automatically."
            }
        },
        "login": "Log In",
        "more": "Further information",
        "save_contact": "Save my information",
        "save_more": "Register my information",
        "save_site": "Register my site",
        "signup": "Register",
        "site": "My main website",
        "skip_site": "later",
        "submit": "Register",
        "title": "Create my Securing account"
    },
    "reviews": {
        "list": {
            "created_at": "Date of writing",
            "dialogs": {
                "cancel": {
                    "text": "Do you confirm the cancellation of the modifications in progress?",
                    "title": "cancellation"
                },
                "remove": {
                    "text": "Do you confirm the deletion of your review? Please note that there will no longer be any trace of your opinion.",
                    "title": "Confirmation of deletion"
                },
                "validate": {
                    "text": "Do you confirm the modification of the moderation status?",
                    "title": "Moderation Status"
                }
            },
            "empty": "No posts were found for your account.",
            "filters": {
                "created_at": "Publication date",
                "group_default": "All my groups",
                "group_title": "Filtering by group",
                "label": "Filters",
                "moderate": "moderate",
                "order": {
                    "asc": "Descending sort",
                    "desc": "Ascending sort"
                },
                "private": "Personal note",
                "rating": "Note",
                "search_title": "Filtering by keywords",
                "securating": "Exclude SR Reviews"
            },
            "group": {
                "intro": {
                    "me": "Private notice"
                }
            },
            "item": "My selected review",
            "loading": "Loading...",
            "menu_name": "My reviews",
            "moderate": "Moderation Status",
            "moderated": "moderate",
            "not-moderated": "Not moderated",
            "private": "Personal note",
            "product": {
                "intro": {
                    "manager": "Product Notice: ",
                    "me": "Your opinion about the product: "
                }
            },
            "rating": "Rating of my review",
            "response": "Site Response",
            "review-link": "See my review on the site",
            "thematic": {
                "intro": {
                    "manager": "Notice regarding: ",
                    "me": "Your opinion about: "
                }
            },
            "title": "List of my reviews",
            "update": {
                "buttons": {
                    "cancel": "Undo my changes",
                    "delete": "Delete my review",
                    "reply": "REPLY",
                    "unvalidate": "Invalidate my review",
                    "update": "Edit my review",
                    "validate": "Validate my opinion"
                },
                "edit": "Change my opinion",
                "group_public": "Public Notice",
                "message": "Message",
                "response": "REPLY",
                "review": "View",
                "title": "title"
            },
            "updated_at": "Date of last update"
        },
        "validate": {
            "menu_name": "Validation of publications",
            "title": "Validate my posts"
        }
    },
    "social": {
        "email": {
            "clear": "Delete Content",
            "contacts": "e-mail",
            "error": "You have already sent an email to the following contacts",
            "menu_name": "By email",
            "message": "Message",
            "send": "Your emails have been sent successfully",
            "subject": "Email Subject",
            "submit": "Send email",
            "template": {
                "message": "Hello,\n\nYou should watch Securating.\n\nIt's really great to know if you can trust a site. There are online reviews posted by visitors!\n",
                "subject": "Securating allows you to consult 100% free opinions!"
            },
            "title": "Invite your friends by email"
        },
        "facebook": {
            "menu_name": "facebook",
            "share": "Share On Facebook",
            "title": "Invite your friends on Facebook"
        },
        "history": {
            "body": "Message",
            "date": "Dispatch",
            "from": "Origin ",
            "menu_name": "My email history",
            "subject": "Topic",
            "title": "History of emails sent",
            "to": "Recipient"
        },
        "invite": {
            "email": "What is his email?",
            "first_name": "What is your friend's first name?",
            "menu_name": "Invite a friend to give their opinion",
            "message": "Do you have a message to add for your friend?",
            "message_placeholder": "For example, a short note on the reason for your request...",
            "thematic": "What question would you like to ask your friend?",
            "title": "Ask your friends for their opinion on a particular site",
            "website": "For which website?",
            "website_error": "The site cannot be reached",
            "website_placeholder": "https://le-site-a-visiter.com"
        },
        "linkedin": {
            "menu_name": "linkedIn",
            "share": "Share Securing on Linkedin",
            "title": "Invite your friends on linkedin"
        },
        "promote": {
            "menu_name": "Make Securing known",
            "title": "Thank you for helping us to promote Securating"
        },
        "title": "Invitations",
        "twitter": {
            "menu_name": "Twitter",
            "message": "Your Tweet",
            "share": "Share Securing on Twitter",
            "title": "Invite your friends on Twitter"
        },
        "warning": "You can only send this information mail to your friends, Securating does not keep any information on your sends.",
        "whatsapp": {
            "menu_name": "Whatsapp",
            "message": "Message",
            "phone": "Contact Number",
            "share": "Share Securing on WhatsApp",
            "title": "Invite your friends on WhatsApp"
        }
    },
    "stories": {
        "create": {
            "cancel": "Cancel",
            "menu_name": "New story",
            "save": "Create my story",
            "title": "Tell your story"
        },
        "list": {
            "menu_name": "Stories"
        },
        "manager": {
            "dialogs": {
                "cancel": {
                    "text": "Do you confirm the cancellation of the modifications in progress?",
                    "title": "cancellation"
                },
                "publish": {
                    "text": "Do you confirm the passage of this story in public?",
                    "title": "Moderation Status"
                },
                "remove": {
                    "text": "Do you confirm the deletion of the story? You cannot go back.",
                    "title": "Confirmation"
                },
                "report": {
                    "text": "Would you like to report this story?\n The confidence level of will decrease drastically and will not be displayed. <br>Warning ! Reporting a story for the wrong reasons may result in penalties.\n",
                    "title": "Report a review"
                }
            },
            "editor": {
                "cancel": "discard changes",
                "html": "Content of the story",
                "image": "Image provided by the user",
                "render": "Story rendering",
                "save": "Save changes",
                "template": "Template chosen by the user"
            },
            "error": {
                "fetch_stories": "Unable to load story list",
                "fetch_websites": "Failed to load list of sites",
                "patch_story": "Error updating story"
            },
            "list": {
                "confidence": "Confidence Percentage",
                "created_at": "Publication date",
                "host": "Click here to see the story on the page",
                "likes_counter": "Number of likes",
                "moderation": "Moderation Status",
                "nothing": "...",
                "published": "Published",
                "rejected": "Rejected",
                "reload": "Reload",
                "search": "Search reviews",
                "title": "List of Stories",
                "waiting": "Waiting",
                "websites": "Choose a site to moderate"
            },
            "render": {
                "edit": "Edit story",
                "publish": "Publish the Story",
                "published": "Story published and visible to your visitors",
                "reason": "Reason for rejection",
                "rejected": "Story rejected and invisible to your visitors"
            },
            "response": {
                "buttons": {
                    "back": "Previous",
                    "cancel": "discard changes",
                    "delete": "Delete answer",
                    "edit": "Edit answer",
                    "publish": "Publish the Story",
                    "reply": "REPLY",
                    "report": "Reject the story",
                    "start": "Return",
                    "update": "following"
                },
                "message": "Give an answer (optional)",
                "pertinence": "Story relevance",
                "publish": "Publish the story to make it visible",
                "report": {
                    "1": "rude or vulgar",
                    "2": "Discrimination, incitement to hatred",
                    "3": "Public humiliation",
                    "4": "Spam",
                    "5": "Commercial content or self-promotion",
                    "6": "Private communication message",
                    "7": "Security, fraud or legal issue",
                    "8": "Threatens the physical integrity of a person",
                    "9": "Violation of a person's privacy",
                    "label": "Reason for rejection",
                    "title": "Report the story"
                },
                "title": "Publishing the story",
                "update_date": "{date}"
            }
        },
        "me": {
            "dialogs": {
                "remove": {
                    "text": "Do you confirm the deletion of the story? You cannot go back.",
                    "title": "Confirmation"
                }
            },
            "editor": {
                "cancel": "Close and discard my changes",
                "html": "Message from your Story",
                "image": "Image of your Story",
                "render": "Appearance of your Story",
                "save": "Save my changes",
                "template": "Organizing Your Story",
                "url": "Your Story is visible on the site"
            },
            "empty": {
                "content": "This space is dedicated to sharing positive experiences.<br>Tell us here your little story in connection with this site.<br>",
                "image_url": "https://cdn.securating.io/static/image/799d1aa84b35aa7470a8f115332af340e805386cae507e670844b7d26f2d9609",
                "title": "Tell your story"
            },
            "error": {
                "fetch_stories": "Unable to load story list",
                "patch_story": "Error updating story",
                "post_story": "Error creating story"
            },
            "list": {
                "created_at": "Publication date",
                "host": "Click here to see your Story on the page",
                "likes_counter": "Number of likes",
                "moderation": "Moderation Status",
                "nothing": "...",
                "published": "Published",
                "rejected": "Rejected",
                "title": "List of my Stories",
                "waiting": "Waiting"
            },
            "render": {
                "edit": "Change my Story",
                "published": "This Story has been published and is visible on the site",
                "reason": "Reason for rejection",
                "rejected": "This Story has been rejected and is not visible on the site"
            },
            "response": {
                "buttons": {
                    "back": "Previous",
                    "cancel": "discard changes",
                    "delete": "Delete answer",
                    "edit": "Edit answer",
                    "publish": "Publish the Story",
                    "reply": "REPLY",
                    "report": "Reject the story",
                    "start": "Return",
                    "update": "following"
                },
                "message": "Give an answer (optional)",
                "pertinence": "Story relevance",
                "publish": "Publish the story to make it visible",
                "report": {
                    "1": "rude or vulgar",
                    "2": "Discrimination, incitement to hatred",
                    "3": "Public humiliation",
                    "4": "Spam",
                    "5": "Commercial content or self-promotion",
                    "6": "Private communication message",
                    "7": "Security, fraud or legal issue",
                    "8": "Threatens the physical integrity of a person",
                    "9": "Violation of a person's privacy",
                    "label": "Reason for rejection",
                    "title": "Report the story"
                },
                "title": "Publishing the story",
                "update_date": "{date}"
            }
        }
    },
    "suggestions": {
        "params": {
            "bt": {
                "clear": "Delete Content",
                "send": "Save these settings"
            },
            "form": {
                "exclude": "Domain names or negative words",
                "excludePlaceHolder": "indicate here the prohibited words (one per line)",
                "exclude_domains": "Exclude a site suggested by Securating's suggestion robot",
                "exclude_word": "Add a negative keyword",
                "exclude_word_add": "Exclude keyword",
                "exclude_word_placeholder": "Type your keyword here, then press the enter key",
                "wanted_label": "Suggestions are visible on your site",
                "wanted_title": "Showing suggestions",
                "website_not_selected": "Select a site to continue",
                "website_title": "Site for which you want to set suggestions"
            },
            "menu_name": "Settings",
            "messages": {
                "sendDone": "Updated setting.",
                "sendError": "An error has occurred, please rephrase your request."
            },
            "title": "Setting up suggestions for your site",
            "website": "Site to configure"
        },
        "url": {
            "menu_name": "Your pages",
            "title": "Managing your pages"
        }
    },
    "thematics": {
        "dialogs": {
            "main": {
                "newcode": "Enter here only the last 3 digits of the desired identifier",
                "title": "Survey topic"
            }
        },
        "form": {
            "delete": "Do you really want to delete this topic?",
            "new": "Add a new topic",
            "title": "Select survey topics ",
            "title_generic": ", survey by languages: "
        },
        "refresh": "Loading",
        "scope": {
            "private": "Yes",
            "public": "No"
        },
        "table": {
            "actions": "Actions",
            "description": "Help collecting reviews",
            "id": "Code",
            "scope": "Target",
            "thematic": "Survey topic"
        }
    },
    "urls": {
        "dialogue": {
            "statistics": {
                "datatable": {
                    "affichage": "Number of displays on remote sites",
                    "date": "Date display"
                },
                "title": "Number of times this page appears in suggestions on other websites"
            }
        },
        "url": {
            "cancel_description": "Cancel",
            "cancel_keywords": "Cancel",
            "cancel_title": "Cancel",
            "cancel_url": "Cancel",
            "datatable": {
                "actions": "Actions",
                "description": "Description",
                "keywords": "Keywords",
                "label": "List of pages",
                "no_keywords": "No",
                "suggestions_updated_at": "Suggestions update",
                "title": "title",
                "url": "Url"
            },
            "delete_url": "Delete URL",
            "description_action": "Edit description",
            "edit_description": "Enter a description",
            "edit_keywords": "Select up to four keywords.",
            "edit_title": "enter a title",
            "edit_url": "Enter a URL",
            "errors": {
                "0acff2d0-32f7-11eb-a735-2f611aedb318": "The length of the title cannot exceed 70 characters.",
                "1038bc74-364f-11eb-8444-d3865411da55": "Keyword update failed",
                "19168722-3573-11eb-be6d-7f7c9e8bc010": "The creation of the new URL failed due to an internal error.",
                "23ad9d02-32f7-11eb-88da-6bcceec010f0": "The length of the description cannot exceed 160 characters.",
                "3bebb86c-32f8-11eb-a3e4-8f2040bd40e2": "Cannot add more than four keywords per URL.",
                "51b60d90-32f4-11eb-8f47-43249515f200": "The entered URL is malformed",
                "7e8c6e5c-364d-11eb-a515-8f30001227e5": "Title update failed.",
                "8439658a-364d-11eb-8ec6-5fb06059d5ed": "Description update failed",
                "9565ae58-32f7-11eb-a5df-a784fb9d328e": "The length of the URL cannot exceed 2056 characters.",
                "aa0ea050-3647-11eb-9f84-ff3891b3cea7": "The creation of the new URL failed due to an internal error.",
                "alert": "Please correct the following error|Please correct the following errors",
                "b461b9ca-357f-11eb-91cf-178b8457856f": "The URL already exists, it must be visible in the list.",
                "c04d220e-364e-11eb-816e-2f9733cf06f2": "Keyword update failed",
                "c6cd8470-3581-11eb-a1fb-1fc03576ef28": "Unable to create the URL due to an internal error, please try again later.",
                "cc2c6b56-3569-11eb-9e40-6733a07f9012": "Unable to add a new URL for this site",
                "description_counter": "The length of the description cannot exceed 160 characters.",
                "e1fa18ba-364b-11eb-95ab-3f2f1b5d5b92": "Unable to lock URL.",
                "e24e4ac0-364b-11eb-a759-cb97a9ea6fb2": "Unable to update due to an internal error.",
                "e2965b26-364b-11eb-be3b-2358e8d68a62": "Unable to update due to an internal error.",
                "f9b3c4a2-363b-11eb-a4f5-9b1b8814efdf": "The creation of the new URL failed due to an internal error.",
                "fde3c72e-364b-11eb-a311-6f6ae0e47a2f": "Failed to unlock URL.",
                "keywords_counter": "Cannot add more than four keywords per URL.",
                "no_selected_website": "First select a site to reference.",
                "title_counter": "The length of the title cannot exceed 70 characters."
            },
            "has_not_right_plan": "You do not have the right subscription to change the keywords for this site. Upgrade to SMART or higher.",
            "keyword_action": "Edit keywords",
            "lock": "Lock URL modification by Securating",
            "menu_name": "Manage my SEO",
            "new_url": "Add a new URL",
            "save_description": "Save Description",
            "save_keywords": "Save keywords",
            "save_title": "save title",
            "save_url": "Save new URL",
            "search": "Search",
            "search_label": "Filter the list",
            "stats": "Statistics",
            "stats_suggestions": "{counter} displays of suggestions on this site.",
            "success": {
                "delete_url": "The URL has been removed.",
                "description_save": "The description has been saved.",
                "keywords_save": "The keywords have been saved.",
                "locked": "The URL has been locked.",
                "title_save": "The title has been saved.",
                "unlocked": "The URL has been unlocked."
            },
            "suggestions": "Open suggestions on the site",
            "title": "Manage your URLs",
            "title_action": "Edit title",
            "unlock": "Unlock URL modification by Securating",
            "update_description": "Update Description",
            "update_keywords": "Update Keywords",
            "update_title": "Update title",
            "url_action": "Open this page",
            "website": "Site to reference",
            "website_not_selected": "Select a site to continue"
        }
    },
    "wall": {
        "manager": {
            "editor": {
                "activity": "Tell us more about your business",
                "claim": "Claim your domain name now",
                "claim_domain": "Retrieve this domain name",
                "claimed": "Tell us about your business",
                "confirm": {
                    "delete": "Are you sure you want to permanently delete your page? You won't be able to go back afterwards..."
                },
                "delete_wall": "delete my page",
                "domain": "Your domain name",
                "domain_prefix": "https://securing.pro/",
                "domain_suffix": "/",
                "errors": {
                    "delete": "Error deleting personal page.",
                    "update": "Error while updating personal page."
                },
                "form": {
                    "address": "Your business address",
                    "category": "Activity area",
                    "description": "Page content",
                    "images": "imagery",
                    "meta_description": "meta-description",
                    "meta_tags": "Keywords",
                    "meta_title": "Meta title",
                    "title": "Page Title"
                },
                "meta": "Meta information of your page for referencing (SEO)",
                "success": {
                    "delete": "Personal page deleted.",
                    "update": "Personal page updated."
                },
                "title": "My personal page",
                "update_wall": "Update my page"
            }
        }
    },
    "websites": {
        "authorized": "Changes to information about your site",
        "copied": "Copy",
        "delete": "Delete this site",
        "delete_image": "Remove",
        "dialogs": {
            "actions": {
                "btn_change_key": "Change the activation key for this site",
                "btn_count": "Re-calculate the rating of this site",
                "btn_delete": "Delete this site",
                "btn_verify": "Check this site key",
                "label_actions": "Possible updates",
                "label_actions_criticals": "Critical operations of this site",
                "title": "Other actions on your site",
                "attestation": "Attestation"
            },
            "edit": {
                "tabs" : {
                    "notification" : {
                        "title" : "Alerts"
                    },
                    "contact" : {
                        "title" : "Contact"
                    },
                    "share" : {
                        "title" : "Shares"
                    },
                    "display" : {
                        "title" : "Display"
                    }
                },
                "label_contact_title": "This information is displayed on the certificate of your site",
                "label_contact_logo": "Your website logo",
                "label_contact_email": "Email",
                "label_contact_phone": "Phone",
                "label_contact_headline": "Your site's tagline",
                "label_contact_public_name": "Your site's public name",
                "label_contact_street": "Address",
                "label_contact_further_information": "Additional address",
                "label_contact_zip": "Zip",
                "label_contact_city": "City",
                "label_contact_country": "Country",

                "label_authorized": "Websites authorized to display service notices from this site",
                "label_menu": "Viewing the Securing Extension Menu",
                "label_notification_email": "Email Notification",
                "label_notification_name": "Contact Name",
                "menu_no": "No, the extension is not yet offered to your visitors",
                "menu_yes": "Yes, the extension is offered to your visitors",
                "title": "Setting up your site"
            },
            "remove": {
                "text": "Do you confirm the deletion of the site?",
                "title": "Deletion of the site"
            },
            "reset": {
                "text": "Do you confirm the change of the activation key?",
                "title": "Change activation key"
            },
            "tokens": {
                "available": "Subscriptions token available",
                "color_0": "#b8b8b8",
                "color_1": "#ff6b00",
                "color_2": "#28a745",
                "color_3": "#007bff",
                "color_4": "#ffc107",
                "nothing_available": "No subscription token available",
                "nothing_used": "No subscription token used",
                "plan_0": "Free",
                "plan_1": "Start",
                "plan_2": "Smart",
                "plan_3": "Max",
                "plan_4": "No limit",
                "plan_99": "plan-99",
                "text": "Which subscription token do you want to use on this site?",
                "source": "Your tokens are created with your subscription [MY ACCOUNT / SUBSCRIPTIONS].",
                "title": "Allocation of subscriptions tokens"
            }
        },
        "download": {
            "title": "Download this site's reviews",
            "requested": "Your file is in preparation"
        },
        "editor": {
            "menu_name": "Personal page"
        },
        "form": {
            "host": "Add",
            "title": "New website",
            "add_host": "Add your new website here..."
        },
        "not_copied": " not copied to clipboard",
        "plan": {
            "change": "CHANGE SUBSCRIPTION"
        },
        "rate": "Calculate the rating of this site",
        "refresh": "Refresh the list of sites",
        "reset": "Change activation key",
        "reviews_params": {
            "bt": {
                "send": "Save these settings"
            },
            "form": {
                "exclude_free_label": "Unsolicited reviews",
                "exclude_thematic_label": "Reviews from a survey",
                "exclude_title": "Hide the following Site Reviews from visitors",
                "order_best_label": "Top rated reviews are displayed first",
                "order_last_label": "The most recent reviews are displayed first",
                "order_liked_label": "The most liked reviews are displayed first",
                "order_pertinent_label": "The most relevant reviews are displayed first",
                "order_title": "Initial display order of published notices",
                "website_title": "Site for which you want to configure the display of reviews",
                "legal_link_title": "Publication rules",
                "legal_link_placeholder": "Link on your website",
                "ext_review_url_title": "Link for external reviews deposit",
                "ext_review_url_placeholder": "Your provider link"
            },
            "menu_name": "Settings",
            "messages": {
                "sendDone": "Updated setting.",
                "sendError": "An error has occurred, please rephrase your request."
            },
            "title": "Setting the display of reviews on your sites",
            "website": "Site to configure"
        },
        "sites": {
            "menu_name": "My Sites",
            "title": "Activate your websites"
        },
        "table": {
            "actions": "Actions",
            "hash": "Activations",
            "host": "Sites",
            "plan": "Subscriptions",
            "status": "stock",
            "title": "Your websites"
        },
        "title": "Managing your sites",
        "title_key": "Click to download the activation key",
        "verification": {
            "level0": "Your site's activation key could not be verified.",
            "level1": "The activation key has been verified, install the plugin to finalize your installation.",
            "level2": "Your site has been verified."
        },
        "verified_l0": "Your website has not been verified. Install the activation key then request verification of your site.",
        "verified_l1": "Your website has been verified.",

        "verify": "Check this site"
    }
}
